var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.5H2C1.66848 0.5 1.35054 0.631696 1.11612 0.866116C0.881696 1.10054 0.75 1.41848 0.75 1.75V11.75C0.75 12.0815 0.881696 12.3995 1.11612 12.6339C1.35054 12.8683 1.66848 13 2 13H7V15.5H4.5V16.75H14.5V15.5H12V13H17C17.3315 13 17.6495 12.8683 17.8839 12.6339C18.1183 12.3995 18.25 12.0815 18.25 11.75V1.75C18.25 1.41848 18.1183 1.10054 17.8839 0.866116C17.6495 0.631696 17.3315 0.5 17 0.5ZM10.75 15.5H8.25V13H10.75V15.5ZM17 11.75H2V1.75H17V11.75Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePos);
export default __webpack_public_path__ + "static/media/whitePos.79646bc4a22978fe0cd30ac37dfe052b.svg";
export { ForwardRef as ReactComponent };